import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(LocalizedFormat);
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);

/**
 * Method used to get the total number of days from an interval.
 *
 * @param startDate
 * @param endDate
 *
 * @returns the number of days from an interval
 */
export function getDateIntervalInDays(startDateStr, endDateStr) {
  const startDate = dayjs(startDateStr).startOf("day");
  const endDate = dayjs(endDateStr).endOf("day");

  const days = endDate.diff(startDate, "day");

  return days;
}

/**
 * Function to convert standard date to selected format.
 *
 * @param dateToFormat Date to format.
 * @param format Format to use.
 *
 * @returns Date in selected format.
 */
export function getLocalizedDateFormat(dateToFormat, format) {
  const localDate = dayjs(dateToFormat).format(format);

  return localDate;
}

/**
 * Get the time from now.
 *
 * @param date Date from which to get the time from now.
 *
 * @returns The time from now.
 */
export function getTimeFromNow(date) {
  return dayjs(date).local().fromNow();
}

export function getDiffInDays(date) {
  const today = dayjs().startOf("day");

  const lastStreakDate = dayjs(date).startOf("day");
  const diffInDays = today.diff(lastStreakDate, "day");

  return diffInDays;
}

export function formatDuration(timeString) {
  if (!timeString) {
    return "";
  }
  // Split the time string into hours and minutes
  const [hours, minutes] = timeString.split(":").map(Number);

  // Create the duration object using the hours and minutes
  const durationObj = dayjs.duration({ hours, minutes });

  // Get the hours and minutes
  const hoursFormatted = durationObj.hours();
  const minutesFormatted = durationObj.minutes();

  // Format the output, removing minutes if they are 0
  if (hoursFormatted > 0 && minutesFormatted > 0) {
    return `${hoursFormatted}h ${minutesFormatted}m`;
  } else if (hoursFormatted > 0) {
    return `${hoursFormatted}h`;
  } else {
    return `${minutesFormatted}m`;
  }
}
